import { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { create, update } from "../../services/upload-files.service";
import { useDispatch, useSelector } from "react-redux";
import { addSupplier, start, updateSupplier } from "../../store/slices/TeamManagementSlice";
import DropdownCheckbox from "./DropdownCheckbox";

const AddSupplier = ({ selectedRow, setShowOffcanvas, showOffcanvas, setSelectedRow, operation }) => {
    const [formData, setFormData] = useState();
    const [errors, setErrors] = useState({});
    const empLoadMaster = useSelector((state) => state.teammanagement.data.mastereditemp);
    const dispatch = useDispatch();
    const userdetails = JSON.parse(localStorage.getItem('userdetails'));
    
    const initialFormState = {
        id: "",
        name: "",
        email: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        status: "",
        contact_person_name: "",
        supervisor_id: "",
        department_id: [],
        contact: ""
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setSelectedRow((prevSelectedRow) => ({
            ...prevSelectedRow,
            [name]: value
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: ""
        }));
    };

    const validateForm = () => {
        const newErrors = {};

        if (selectedRow.name.trim() === "") {
            newErrors.name = "Please Enter Supplier Name";
        }

        if (selectedRow.contact_person_name.trim() === "") {
            newErrors.contact_person_name = "Please Enter Contact Person Name";
        }

        if (selectedRow.email.trim() === "") {
            newErrors.email = "Please Enter Correct Email Address";
        } else if (!validateEmail(selectedRow.email)) {
            newErrors.email = "Please Enter a Valid Email Address";
        }

        if (selectedRow.contact.trim() === "") {
            newErrors.contact = "Please Enter Mobile Number";
        } else if (!validateContact(selectedRow.contact)) {
            newErrors.contact = "Please Enter a Valid Mobile Number";
        }

        if (selectedRow.department_id.length == 0) {
            newErrors.department_id = "Please Select Department";
        }

        if (selectedRow.supervisor_id === "") {
            newErrors.supervisor_id = "Please Select Supervisor";
        }

        if (selectedRow.address.trim() === "") {
            newErrors.address = "Please Enter Address";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const validateContact = (contact) => {
        const re = /^[0-9]{10}$/;
        return re.test(contact);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (validateForm()) {
            setFormData(operation === "update"
                ? {
                    id: selectedRow.id,
                    name: selectedRow.name,
                    email: selectedRow.email,
                    address: selectedRow.address,
                    city: selectedRow.city,
                    state: selectedRow.state,
                    zip: selectedRow.zip,
                    country: selectedRow.country,
                    status: selectedRow.status,
                    contact_person_name: selectedRow.contact_person_name,
                    supervisor_id: selectedRow.supervisor_id,
                    department_id: JSON.stringify(selectedRow.department_id),
                    contact: selectedRow.contact
                }
                : {
                    name: selectedRow.name,
                    email: selectedRow.email,
                    address: selectedRow.address,
                    city: selectedRow.city,
                    state: selectedRow.state,
                    zip: selectedRow.zip,
                    country: selectedRow.country,
                    status: selectedRow.status,
                    contact_person_name: selectedRow.contact_person_name,
                    supervisor_id: selectedRow.supervisor_id,
                    department_id: JSON.stringify(selectedRow.department_id),
                    contact: selectedRow.contact,
                    company_id: userdetails.company_id
                }
            );

            setShowOffcanvas(false);
        }
    };

    useEffect(() => {
        if (formData) {
            dispatch(start());
            if (operation === "create") {
                create(formData, "suppliers").then((res) => {
                    dispatch(addSupplier(res));
                });
            } else {
                update(formData, "suppliers").then((res) => {
                    dispatch(updateSupplier(res));
                });
            }
        }
    }, [formData, dispatch]);

    const resetForm = () => {
        setSelectedRow(initialFormState);
        setErrors({});
    };

    const handleClose = () => {
        resetForm();
        setShowOffcanvas(false);
    };

    return (
        <>
            <Offcanvas
                show={showOffcanvas}
                onHide={handleClose}
                placement="end"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{operation === "create" ? "Add" : "Edit"} Supplier</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={handleSubmit} onReset={resetForm}>
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">
                                Supplier Name:
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="name"
                                name="name"
                                aria-describedby="nameHelp"
                                value={selectedRow.name}
                                onChange={handleInputChange}
                            />
                            {errors.name && <span className="text-danger">{errors.name}</span>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="contact_person_name" className="form-label">
                                Contact Person Name:
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="contact_person_name"
                                name="contact_person_name"
                                aria-describedby="contactpersonnameHelp"
                                value={selectedRow.contact_person_name}
                                onChange={handleInputChange}
                            />
                            {errors.contact_person_name && <span className="text-danger">{errors.contact_person_name}</span>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">
                                Email:
                            </label>
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                name="email"
                                aria-describedby="emailHelp"
                                value={selectedRow.email}
                                onChange={handleInputChange}
                            />
                            {errors.email && <span className="text-danger">{errors.email}</span>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="contact" className="form-label">
                                Contact Number:
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="contact"
                                name="contact"
                                aria-describedby="numberHelp"
                                value={selectedRow.contact}
                                onChange={handleInputChange}
                            />
                            {errors.contact && <span className="text-danger">{errors.contact}</span>}
                        </div>
                        <div className="mb-3">
                            <DropdownCheckbox departments={empLoadMaster.departments} selectedRow={selectedRow} setSelectedRow={setSelectedRow} />
                            {errors.department_id && <span className="text-danger">{errors.department_id}</span>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="supervisor_id" className="form-label">
                                Supervisor:
                            </label>
                            <select
                                className="form-select"
                                name="supervisor_id"
                                id="supervisor_id"
                                aria-label="Default select example"
                                onChange={handleInputChange}
                                value={selectedRow.supervisor_id}
                            >
                                <option value="">
                                    Select Supervisor
                                </option>
                                {empLoadMaster.supervisors && empLoadMaster.supervisors.length > 0 ? (
                                    empLoadMaster.supervisors.map((sup) => (
                                        <option key={sup.id} value={sup.id}>
                                            {sup.name}
                                        </option>
                                    ))
                                ) : (
                                    <option disabled>No Employee data available.</option>
                                )}
                            </select>
                            {errors.supervisor_id && <span className="text-danger">{errors.supervisor_id}</span>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="address" className="form-label">
                                Address:
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="address"
                                name="address"
                                aria-describedby="addressHelp"
                                value={selectedRow.address}
                                onChange={handleInputChange}
                            />
                            {errors.address && <span className="text-danger">{errors.address}</span>}
                        </div>

                        <button type="submit" className="btn btn-primary btn-add">
                            {operation === "create" ? "Add" : "Update"}
                        </button>
                        <button type="reset" className="btn btn-primary btn-add ms-2">
                            Reset
                        </button>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default AddSupplier;